import { render, staticRenderFns } from "./SetPublic.vue?vue&type=template&id=1d569b66&"
import script from "./SetPublic.vue?vue&type=script&lang=js&"
export * from "./SetPublic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports